@import '../../fonts.css';
/* VARIABLES */
/* COLOR VARIABLES */
.box-frame {
  box-shadow: 5px 4px 16px 0 rgba(0, 0, 0, 0.03);
  border: 3px solid #d9d9d9;
}
.box-popup-frame {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid #d9d9d9;
}
/* grey border used by antd divider */
* {
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.hideScrollbar::-webkit-scrollbar {
  display: none;
}
body {
  font-family: 'Ageo', sans-serif;
  font-size: 0.9375rem;
  margin: 0;
}
a,
a:active,
a:hover {
  color: #e6008c;
}
/* Front page "Loading..." spinner */
.ant-spin {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 0.9375rem;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  display: none;
  color: #1890ff;
  text-align: center;
  vertical-align: middle;
  opacity: 0;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-spin-spinning.preloader {
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100vw;
  height: 100vh;
  padding-bottom: 25px;
}
.ant-spin-dot {
  position: absolute;
}
.ant-spin__text {
  padding-top: 70px;
  color: lightgrey;
}
/* <Button /> */
.ant-btn {
  height: 2.25rem;
  padding: 0.25rem 1.5rem;
  font-size: 0.9375rem;
}
.ant-btn > i,
.ant-btn > span {
  display: inline;
}
.ant-btn > span:not(.anticon) {
  padding-top: 2px;
}
.ant-btn-primary {
  background-color: #e6008c;
  border-color: #e6008c;
}
.ant-radio-group-solid > .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background-color: #e6008c;
  border-color: #e6008c;
  box-shadow: -1px 0 0 0 #e6008c;
}
.ant-radio-group-solid > .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus,
.ant-radio-group-solid > .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #FFF;
  background-color: #b3006d;
  border-color: #e6008c;
}
.ant-radio-button-wrapper:hover {
  color: #e6008c;
}
.ant-btn.active,
.ant-btn:active,
.ant-btn:focus,
.ant-btn:hover {
  color: #e6008c;
  border-color: #e6008c;
}
.ant-btn-primary.active,
.ant-btn-primary:active,
.ant-btn-primary:focus,
.ant-btn-primary:hover {
  color: #FFF;
  background-color: #b3006d;
}
/* <Table /> */
.ant-table {
  font-size: 0.9375rem;
  font-weight: 400;
}
.ant-table .ant-table-tbody,
.ant-table .ant-table-body,
.ant-table .ant-table-thead,
.ant-table .ant-table-thead th {
  background-color: #FFF;
}
.ant-table .ant-table-thead th,
.ant-table .ant-table-tbody td {
  padding: 1em;
}
.ant-table .ant-table-thead > tr > th,
.ant-table .ant-table-thead > tr > th .ant-table-column-title,
.ant-table .ant-table-thead > tr > th .ant-table-column-sorters {
  font-weight: bold;
}
.ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td,
.ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td,
.ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td,
.ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
  background: #EEEEEE;
}
.ant-table-tbody > tr.ant-table-expanded-row {
  background: #d9d9d9;
}
/* PAGINATION */
.ant-pagination-item-active,
.ant-pagination-item-active:focus,
.ant-pagination-item-active:hover,
.ant-pagination-item-active a,
.ant-pagination-item-active:focus a,
.ant-pagination-item-active:hover a {
  color: #e6008c;
}
/* <Menu /> */
.ant-layout-sider,
.ant-menu.ant-menu-dark {
  background-color: #555555;
}
.ant-menu-inline .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title {
  height: auto;
  padding: 0.33333333rem;
  font-size: 0.9375rem;
}
.ant-menu-inline .ant-menu-submenu .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu .ant-menu-item {
  height: auto;
  padding-top: 0.33333333rem;
  padding-bottom: 0.33333333rem;
}
.ant-menu-inline .ant-menu-submenu .ant-menu-submenu-title a,
.ant-menu-inline .ant-menu-submenu .ant-menu-item a {
  color: rgba(255, 255, 255, 0.65);
  /* below trick fits the anchor tag to parent
       * div to increase the clickable area
       */
  display: list-item;
  list-style-type: none;
}
.ant-menu-inline .ant-menu-submenu .ant-menu-submenu-title i.ant-menu-submenu-arrow,
.ant-menu-inline .ant-menu-submenu .ant-menu-item i.ant-menu-submenu-arrow {
  top: 1.8rem;
}
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected,
.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected,
.ant-menu.ant-menu-dark .ant-menu-submenu-open {
  background-color: #242424;
}
/* <Empty /> */
.ant-empty {
  margin: auto;
}
#app {
  height: 100vh;
  width: 100vw;
}
.ant-modal {
  top: 4rem;
}
.ant-modal-footer {
  border-top: none;
  padding-bottom: 1rem;
  text-align: center;
}
.ant-modal-footer .ant-divider {
  margin: 1rem;
  margin-top: 0.5rem;
}
.ant-modal-body {
  font-size: 0.9375rem;
  padding: 0 1.5rem 1rem;
}
.ant-modal-header {
  border-bottom: none;
  padding: 1rem 1.5rem 1.5rem;
}
.ant-modal-title {
  font-size: 1.5rem;
  padding: 1.5rem 1.5rem 0 0;
  text-transform: uppercase;
  text-align: center;
}
/* <Notification /> */
.ant-notification .notification-error {
  border: solid 2px #f5222d;
}
/* Responsive breakpoint variables */
/* Mixins for different screen size */
.clipboard-copy {
  color: #e6008c;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}
.clipboard-copy::after {
  content: " \2398";
}
.ant-picker {
  width: 10.5rem;
}
.ant-form-item-label {
  line-height: 40px !important;
  margin-bottom: -1rem !important;
}
.nomination-form h3 {
  margin: 0 0 1rem 0;
  text-transform: uppercase;
}
.nomination-form__details {
  padding: 1rem 0;
  color: #2B2B2B;
}
.nomination-form__details .ant-col {
  padding-right: 1rem;
}
.nomination-form__details__label {
  margin-bottom: 1rem;
}
.nomination-form__details__label .ant-form-item-label {
  line-height: 1.5 !important;
  margin-bottom: 0 !important;
}
.nomination-form__details__error {
  color: #f5222d;
  margin-top: calc(-1rem/2);
  position: absolute;
}
.nomination-form__date__select {
  width: 100% !important;
}
.nomination-form__amounts .ant-divider {
  margin: calc(1rem/2) 0;
}
.nomination-form__amounts__item {
  display: flex;
  margin-bottom: 0;
}
.nomination-form__amounts__item .ant-form-item-row {
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.nomination-form__amounts__item .anticon-copy {
  font-size: 1.2rem;
  padding-left: 1rem;
  color: #e6008c;
  text-align: right;
}
.nomination-form__amounts__item .ant-form-item-label {
  overflow: unset;
  flex: 0 0 auto;
  max-width: none;
  padding-bottom: 0;
  margin-bottom: 0 !important;
  line-height: normal !important;
}
.nomination-form__amounts__item .ant-form-item-control {
  flex: 1;
  width: auto;
}
.nomination-form__amounts__item__label {
  display: inline-block;
  text-align: left;
  width: 150px;
}
.nomination-form__amounts__item__label span {
  display: block;
  color: #757575;
}
.nomination-form__amounts__item > span:not(.ant-input-number-handler):not(.anticon) {
  margin-left: 1rem;
}
.nomination-form__amounts__input {
  width: 110px;
}
.nomination-form__amounts__span {
  width: 95px;
}
.nomination-form__amounts--compact .ant-divider {
  margin: calc(1rem/2) 0;
}
.nomination-form__amounts--compact .nomination-form__amounts__item .anticon-copy {
  padding-left: calc(1rem / 2);
}
.nomination-form__amounts--compact .nomination-form__amounts__item .nomination-form__amounts__item__label {
  width: 96px;
}
.nomination-form__amounts--compact .nomination-form__amounts__item .nomination-form__amounts__item__label span {
  font-size: 10px;
  line-height: 1.05;
  margin-top: 4px;
  word-break: break-word;
}
.nomination-form__amounts--compact .nomination-form__amounts__item .nomination-form__amounts__input {
  width: 96px;
}
.nomination-form__amounts--compact .nomination-form__amounts__item .nomination-form__amounts__input .ant-input-number-input {
  padding-left: 8px;
  padding-right: 8px;
  text-align: left;
}
.nomination-form__amounts--compact .nomination-form__amounts__item .nomination-form__amounts__span {
  width: 40px;
  min-width: 40px;
}
.nomination-form__amounts--compact .nomination-form__amounts__item .nomination-form__amounts__value {
  width: 96px;
  min-width: 96px;
  box-sizing: border-box;
  padding-left: 8px;
  text-align: left;
}
.nomination-form__amounts--compact .nomination-form__amounts__item .nomination-form__amounts__nomres {
  width: auto;
  min-width: 40px;
  padding-left: 0;
  white-space: nowrap;
}
.nomination-form__amounts--compact .nomination-form__amounts__item > span:not(.ant-input-number-handler):not(.anticon) {
  margin-left: calc(1rem / 2);
}
.nomination-form__instruction-text {
  margin-top: 1rem;
  font-weight: bold;
}
.nomination-form__warning {
  color: inherit;
  margin-top: 8px;
}
.nomination-form__warning__label {
  color: #faad14;
  font-weight: bold;
  margin-right: 4px;
}
.nomination-form__warnings {
  margin-bottom: 1rem;
}
.nomination-form__warnings .nomination-form__warning {
  margin: 0;
}
.nomination-form__shipperEIC__option span.eic {
  float: right;
  opacity: 0.5;
}
.nomination-form__shipperEIC__dropdown .ant-select-dropdown-menu {
  max-height: 400px;
}
.nomination-form__shipperEIC__dropdown .ant-select-dropdown-menu-item-group:first-of-type {
  border-bottom: 2px solid rgba(0, 0, 0, 0.07);
}
.nomination-form__shipperEIC__select .ant-select-selection-selected-value {
  width: 100%;
  padding-right: 25px;
}
.nomination-form__shipperEIC__select span.eic {
  opacity: 0.5;
}
.nomination-form__shipperEIC__select span.eic::before {
  content: '\00A0\2014\00A0';
}
.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  border-color: #FFF;
}
.ant-tooltip-placement-bottomRight .ant-tooltip-inner {
  background: #FFF;
  color: #2B2B2B;
}
.new-nomination__warning-count {
  color: #faad14;
  font-weight: bold;
  font-size: 16px;
  float: right;
  line-height: 32px;
}
